import ExternalClientCatalog from './ExternalClients/ExternalClientCatalog';
import ExternalClientCreation from './ExternalClients/ExternalClientCreation';
import ExternalClientDetails from './ExternalClients/ExternalClientDetails';
import ExternalClients from './ExternalClients';
import ExternalOrderCreation from './ExternalOrders/ExternalOrderCreation';
import ExternalOrderDetails from './ExternalOrders/ExternalOrderDetails';
import ExternalOrders from './ExternalOrders';

const ExternalModule = {
  ExternalClientCatalog,
  ExternalClientCreation,
  ExternalClientDetails,
  ExternalClients,
  ExternalOrderCreation,
  ExternalOrderDetails,
  ExternalOrders,
};

export default ExternalModule;
